module.exports = __webpack_public_path__ + "static/media/performance-no-data-bg.b344dbb9.svg";